import NewsScreen from './NewsScreen'

export default NewsScreen
